import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage/buz-hour-template';

const list = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/branchBusHoursTemplates`,
		payload
	);
};

const locationList = (merchantId, payload) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/manager/${merchantId}/allBusHours`,
		payload
	);
};
const create = (merchantId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/branchBusHoursTemplates`,
		payload
	);
};
const update = (merchantId, templateId, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/branchBusHoursTemplates/${templateId}`,
		payload
	);
};
const find = (merchantId, templateId, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/branchBusHoursTemplates/${templateId}`,
		payload
	);
};
const apply = (merchantId, templateId, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/branches/branchBusHoursTemplate/${templateId}`,
		payload
	);
};
export default { list, locationList, create, update, find, apply };
